import { render, staticRenderFns } from "./FaqsComponent.vue?vue&type=template&id=55e704e6"
import script from "./FaqsComponent.vue?vue&type=script&lang=js"
export * from "./FaqsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports